import React, { useEffect } from 'react';
import { useStripe } from '../contexts/StripeContext';

interface CreditsDisplayProps {
  className?: string;
}

const CreditsDisplay: React.FC<CreditsDisplayProps> = ({ className }) => {
  const { credits, checkCredits } = useStripe();

  useEffect(() => {
    checkCredits();
  }, [checkCredits]);

  return (
    <div className={`flex items-center ${className}`}>
      <span className="text-sm font-medium">
        Research Credits: <span className="font-bold">{credits}</span>
      </span>
    </div>
  );
};

export default CreditsDisplay;
